export default "/public/dist/video/videoLogoPdG.mp4";